<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h1 class="title mb-6">{{ $t('accountInformation') }}</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="8" class="mb-4">
        <box>
          <account-information
            class="mb-9"
            v-model="accountInfo"
            hide-ether-wallet
            hide-neo-wallet
            :errors="errors"
            :selected-roles="selectedRoles"
            :all-roles="roles"
          />
          <social-profiles
            :errors="errors"
            v-model="accountInfo.socialNetworks"
          />
          <payment-accounts :errors="errors" v-model="accountInfo.wallets" />
          <div
            class="settings-form-bottom d-flex align-items-center flex-wrap-reverse"
          >
            <button
              class="btn btn-link-alt"
              @click.prevent="logoutFromAllDevices"
            >
              {{ $t('logoutFromAllDevices') }}
            </button>
            <b-button
              size="lg"
              variant="primary"
              style="padding-left: 4rem; padding-right: 4rem;"
              @click="updateProfile"
              class="ml-auto"
            >
              {{ $t('save') }}
            </b-button>
          </div>
        </box>
      </b-col>
      <b-col cols="12" lg="4">
        <h2 class="title">{{ $t('notes') }}</h2>
        <ul class="pl-4 mb-5">
          <li>{{ $t('connectSocialProfiles') }}</li>
          <!-- <li>
            If another blockchain wallet will be required, it will associated
            with exact bounty program.
          </li>
          <li>
            Make sure not to use wallets from exchanges. For ERC20 MyEtherWallet
            is recommended. For NEP-5 Neon wallet.
          </li> -->
          <li>{{ $t('connectOneAccount') }}</li>
        </ul>
        <!-- <h2 class="title">How to</h2>
        <ul class="pl-4 mb-5">
          <li>
            Link to BitcoinTalk profile: Go to Profile → Summary and copy URL.
          </li>
          <li>Something else to make user feel comfy.</li>
        </ul> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SocialProfiles from './components/SocialProfiles.vue';
import PaymentAccounts from './components/PaymentAccounts.vue';
import editMixin from './../mixins/edit.js';

export default {
  mixins: [editMixin],

  components: {
    SocialProfiles,
    PaymentAccounts
  }
};
</script>
